// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const DynamicImageProviderIcon = registerClientReference(
function() { throw new Error("Attempted to call DynamicImageProviderIcon() from the server but DynamicImageProviderIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/components/ui/DynamicProviderIcon.tsx",
"DynamicImageProviderIcon",
);